import { useProjectStore } from "@/stores/projectStore";

const ProjectTasks = () => {
  const { selectedProjectTasks } = useProjectStore();

  return (
    <div>
      ProjectTasks
      {selectedProjectTasks?.map((projectTask) => {
        return <div>{projectTask?.title}</div>;
      })}
    </div>
  );
};

export default ProjectTasks;
